import React from 'react';
import { Text } from '@amzn/stencil-react-components/text';
import { Expander } from '@amzn/stencil-react-components/expander';

export const QualitySupportPreviousWeekFAQSet: React.FunctionComponent = () => {
  return (
    <>
      <Expander titleText="What is DPMO?">
        <Text>
          Defects Per Million Opportunities is the primary Quality metric used to evaluate quality performance. This ratio shows how many errors would occur across one million transactions.
        </Text>
      </Expander>
      <Expander titleText="What does &quot;Percentile Ranking Compared to Peers&quot; represent?">
        <Text>
          Your &quot;Percentile Ranking Compared to Peers&quot; shows the performance percentage of eligible people at your FC across all Learning Curve Families. For example, if your Percentile Ranking Compared to Peers shows 7%, you were in the top 7% at your site and performed better than 93% of eligible people at your site.
        </Text>
      </Expander>
      <Expander titleText="Why isn't data on my performance compared to peers available?">
        <Text>
          If you don't have data on your performance compared to peers for productivity or quality during a particular week, you may not have been eligible for performance review in that category because:
        </Text>
        <Text>
          <ol type="a">
            <li>You were recently trained in the specific process path</li>
            <li>You recently returned from an extended leave or have not worked in the path for more that 90 days</li>
            <li>You have not worked more than five total hours in a path for the review week, worked in a process path that did not have enough people working in it, or if the process path does not have UPH data available.</li>
          </ol>
        </Text>
        <Text>Note: performance data for quality is pulled Monday-Monday of the prior week and productivity data is pulled Wednesday-Wednesday for the current week.</Text>
      </Expander>
      <Expander titleText="What is an Overage?">
        <Text>
          An Overage is said to occur when there is a discrepancy in inventory such that an item is present physically but not virtually.
        </Text>
      </Expander>
      <Expander titleText="What is a Shortage?">
        <Text>
          An Shortage is said to occur when there is a discrepancy in inventory such that an item is present virtually but not physically.
        </Text>
      </Expander>
    </>
  );
}